import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'

@Injectable({ providedIn: 'root' })
export class RolesAndPermissionsService {
	constructor(private http: HttpClient) {}

	getRolesList(searchText: any = '') {
		let paging = {
			PageNumber: 1,
			PageSize: 10,
		}
		return this.http.get(
			`${ApiEndPoint.GetRolesListApi}?SearchText=${searchText}&PageNumber=${paging.PageNumber}&PageSize=${paging.PageSize}`
		)
	}

	getActiveRolesList(searchText: any = '') {
		
		return this.http.get(
			`${ApiEndPoint.GetActiveRolesListApi}?SearchText=${searchText}`
		)
	}
	assignRoleToUser(roleIds: number[], userId: number) {
		return this.http.post(`${ApiEndPoint.assignRoleToUser}`, {
			roleIds,
			userId,
		})
	}
	getRoleById(roleId: number) {
		return this.http.get(`${ApiEndPoint.GetRoleByIdApi}?RoleId=${roleId}`)
	}

	getPermissionsDetailsById(permissionId: number, searchText?: string) {
		return !searchText
			? this.http.get(
					`${ApiEndPoint.getPermissionDetailsApi}?PermissionId=${permissionId}`
			  )
			: this.http.get(
					`${ApiEndPoint.getPermissionDetailsApi}?PermissionId=${permissionId}&SearchUser=${searchText}`
			  )
	}
	changeRoleActivationStatus(RoleId: number, isActive: boolean) {
		return this.http.put(
			`${ApiEndPoint.changeRoleActivationStatus}?RoleId=${RoleId}&isActive=${isActive}`,
			{}
		)
	}
	deleteRole(roleId: number) {
		return this.http.delete(`${ApiEndPoint.deleteRole}?roleId=${roleId}`)
	}
	getAllPermissions(filter: any) {
		return this.http.post(`${ApiEndPoint.getAllPermissionsApi}`, filter)
	}
	getAllPermissionPage(filter: any) {
		return this.http.post(`${ApiEndPoint.getAllPermissionPage}`, filter)
	}

	createRole(body: any) {
		return this.http.post(ApiEndPoint.CreatRoleApi, body)
	}

	updateRole(body: any) {
		return this.http.put(ApiEndPoint.UpdateRoleApi, body)
	}
}
